import React from 'react';

import styled from 'styled-components';

import { defineMessages, useIntl } from '@techstyle/react-intl';

import { desktop, mobile } from '../../styles';
import { useLDNewShoppingBagUX } from '../../utils/LD/useNewShoppingBagUX';
import { Component as StaticIcon } from '../StaticIcon';

const messages = defineMessages({
  remove: {
    defaultMessage: 'Remove',
    id: 'global_checkout.remove',
  },
});

const Button = styled.button.attrs(({ type = 'button', ariaLabel }) => {
  return {
    type,
    'aria-label': ariaLabel,
  };
})`
  margin-top: -18px;
  ${desktop`
    margin-right: ${props =>
      !props.shoppingBagFlagStatus?.isControl && props.theme.context.cartDrawer
        ? '-10px'
        : '-18px'};
  `}
  ${mobile`
    margin-right: -18px;
  `}

  width: 44px;
  height: 44px;
  cursor: pointer;

  height: 18px;
  vertical-align: middle;
`;

const CloseIcon = styled(StaticIcon).attrs(props => {
  if (
    !props.shoppingBagFlagStatus?.isControl &&
    props.theme.context.cartDrawer
  ) {
    return {
      type: 'trashcan',
      size: 24,
      color: props.theme.colors.gunmetal,
    };
  }
  return {
    type: 'close',
    size: 8,
    color: props.theme.colors.subdued,
  };
})`
  stroke: ${props =>
    !props.shoppingBagFlagStatus?.isControl
      ? props.theme.colors.gunmetal
      : props.theme.colors.subdued};
  stroke-width: ${props =>
    !props.shoppingBagFlagStatus?.isControl ? '0' : '1.5px'};
`;

function CartRemoveButton({ ...props }) {
  const intl = useIntl();
  const shoppingBagFlagStatus = useLDNewShoppingBagUX();

  return (
    <Button
      data-autotag="mini-cart-remove-item"
      ariaLabel={intl.formatMessage(messages.remove)}
      shoppingBagFlagStatus={shoppingBagFlagStatus}
      {...props}
    >
      <CloseIcon shoppingBagFlagStatus={shoppingBagFlagStatus} />
    </Button>
  );
}

export default CartRemoveButton;
